import { useMemo } from "react";

// Create an id value
// Please not that this should not be used for any secure operations
// Example use case: Generate id value for an HTML element
export function useUid() {
    const crypto = window.crypto;
    var array = new Uint32Array(1);
    var randomNumber = crypto.getRandomValues(array)[0];

  const uid = useMemo(() => {
      return randomNumber.toString(36).slice(-6);
  }, []);

  return uid;
}
